import { useRouter } from 'next/router';
import React from 'react';
import { connect } from 'react-redux';

import CommitteesPage from '@/src/committees/components/CommitteesPage';
import withMembershipAccessWrap, {
  mapStateToProps,
} from '@/src/shared/components/MembershipPageWrap';
import { ADVOCACY_ACCESS } from '@/src/shared/constants';

const WorkingGroups = () => {
  const router = useRouter();

  return <CommitteesPage alias="working-groups" router={router} />;
};

export default connect(mapStateToProps)(
  withMembershipAccessWrap(WorkingGroups, ADVOCACY_ACCESS.POLICY_COMMITTEES)
);
